module.exports = __webpack_public_path__ + "img/FEDER7.f77d8ff5.png";